//import React from 'react';
import { intl } from './../../core/globalIntl';

const Regex = {
  email: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
  url: /^(https?)(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)$/,
  //password: /^(?=.*?[a-zA-Z])(?=.*?\d)[!-\~]{8,16}$/,
  password: /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[\s\S]+$/,
  alphabetNumber: /^[0-9a-zA-Z]*$/,
  fullWidth: /^[^\x01-\x7E\xA1-\xDF]+$/,
  time: /^((([012]?[0-9]|3[0-2]):?([0-5][0-9]))|(33:?00))$/,
  time2: /^[\x30-\x3a]+$/,
};

export const required = (value) => {
  return (
    value || typeof value === 'number' ?
      undefined : intl.formatMessage({ id: 'validate.required' })
  );
};

export const maxLength = (value, length) => {
  return (
    value && value.length > length ?
      intl.formatMessage({ id: 'validate.maxLength' }, { length: length }) : undefined
  );
};

export const minLength = (value, length) => {
  return (
    value && value.length < length ?
      intl.formatMessage({ id: 'validate.minLength' }, { length: length }) : undefined
  );
};

export const typeEmail = (value) => {
  return (
    value && !Regex.email.test(value) ?
      intl.formatMessage({ id: 'validate.type.email' }) : undefined
  );
};

export const typeUrl = (value) => {
  return (
    value && !Regex.url.test(value) ?
      intl.formatMessage({ id: 'validate.type.url' }) : undefined
  );
};

export const typePassword = (value) => {
  return (
    value && !Regex.password.test(value) ?
      intl.formatMessage({ id: 'validate.type.password' }) : undefined
  );
};

export const typeNumber = (value) => {
  return (
    value && isNaN(value) ?
      intl.formatMessage({ id: 'validate.type.number' }) : undefined
  );
};

export const typeAlphabetNumber = (value) => {
  return (
    value && !Regex.alphabetNumber.test(value) ?
      intl.formatMessage({ id: 'validate.type.alphabetNumber' }) : undefined
  );
};

export const typeFullWidth = (value) => {
  return (
    value && !Regex.fullWidth.test(value) ?
      intl.formatMessage({ id: 'validate.type.fullWidth' }) : undefined
  );
};

//氏名（漢字）、氏名（ひらがな）、氏名（カタカナ）入力チェック
export const checkPersonalName = (value, allvalues) => {
  return (
    allvalues.PersonalNameTextFiled === '' &&
    allvalues.PersonalHiraTextFiled === '' &&
    allvalues.PersonalKanaTextFiled === '' ?
      intl.formatMessage({ id: 'validate.type.requiredPersonalName' }) : undefined
  );
};

//生年月日入力チェック
export const checkDateOfBirth = (value, allvalues) => {
  if (allvalues.BirthDateYearSelectBox === '' && allvalues.BirthDateMonthSelectBox === '' &&
      allvalues.BirthDateDaySelectBox === '' ){
    //年月日に値が入っていない場合、チェックしない
    return (undefined);
  } else if (allvalues.BirthDateYearSelectBox === '' || allvalues.BirthDateMonthSelectBox === '' ||
             allvalues.BirthDateDaySelectBox === '' ){
    //どれかに値がが入っている場合
    return (intl.formatMessage({ id: 'validate.type.correctDate' }));
  }
  
  let year = String(allvalues.BirthDateYearSelectBox).substring(0,4);
  let month = allvalues.BirthDateMonthSelectBox
  let day = allvalues.BirthDateDaySelectBox
  let strDate = year+'/'+month+'/'+day
  let date = new Date(strDate)
  
  return (
    isNaN(date.getDate()) === true ||
      (date.getFullYear() !=  strDate.split("/")[0] ||
       date.getMonth() != strDate.split("/")[1] - 1 ||
       date.getDate() != strDate.split("/")[2]
      ) ?
      intl.formatMessage({ id: 'validate.type.correctDate' }) : undefined
  );
};

export const arrayRequired = (value) => {
  if (typeof value === "undefined") {
   return (undefined);
  }
  
  return (
    value.length ?
    undefined : intl.formatMessage({ id: 'validate.required' })
  );
};